import React from 'react';
import { CaretDown, CaretUp, Trophy } from '@phosphor-icons/react';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import {
  Card, CardContent, CardHeader, CardTitle,
} from '../../components/ui/card';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../../components/ui/table';

const collectionRateBadgeClass = (rate) => {
  const num = parseFloat(rate);
  if (num >= 80) return 'bg-green-100 text-green-700';
  if (num >= 60) return 'bg-amber-100 text-amber-700';
  return 'bg-red-100 text-red-700';
};

export const AgencyComparisonTab = ({
  rankedAgencies, sortBy, setSortBy, sortOrder, setSortOrder,
}) => (
  <Card className="border-slate-200">
    <CardHeader className="pb-2">
      <div className="flex justify-between items-center">
        <CardTitle className="text-lg">Agency Comparison</CardTitle>
        <div className="flex gap-2">
          <Select value={sortBy} onValueChange={setSortBy}>
            <SelectTrigger className="w-32">
              <SelectValue placeholder="Sort by" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="name">Name</SelectItem>
              <SelectItem value="patients">Patients</SelectItem>
              <SelectItem value="claims">Claims</SelectItem>
              <SelectItem value="billed">Billed</SelectItem>
              <SelectItem value="collected">Collected</SelectItem>
              <SelectItem value="rate">Collection Rate</SelectItem>
            </SelectContent>
          </Select>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
          >
            {sortOrder === 'asc' ? <CaretUp size={16} /> : <CaretDown size={16} />}
          </Button>
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12">#</TableHead>
            <TableHead>Agency</TableHead>
            <TableHead className="text-right">Patients</TableHead>
            <TableHead className="text-right">Employees</TableHead>
            <TableHead className="text-right">Claims</TableHead>
            <TableHead className="text-right">Paid</TableHead>
            <TableHead className="text-right">Denied</TableHead>
            <TableHead className="text-right">Billed</TableHead>
            <TableHead className="text-right">Collected</TableHead>
            <TableHead className="text-right">Rate</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rankedAgencies.map((agency) => (
            <TableRow key={agency.agency_id}>
              <TableCell className="font-medium text-slate-400">{agency.rank}</TableCell>
              <TableCell className="font-medium">
                <div className="flex items-center gap-2">
                  {agency.rank === 1 && <Trophy size={16} className="text-amber-500" />}
                  {agency.agency_name}
                </div>
              </TableCell>
              <TableCell className="text-right">{agency.total_patients}</TableCell>
              <TableCell className="text-right">{agency.total_employees || '-'}</TableCell>
              <TableCell className="text-right">{agency.total_claims}</TableCell>
              <TableCell className="text-right text-green-600">{agency.claims_paid}</TableCell>
              <TableCell className="text-right text-red-600">{agency.claims_denied}</TableCell>
              <TableCell className="text-right font-medium">
                ${(agency.total_billed || 0).toLocaleString()}
              </TableCell>
              <TableCell className="text-right">
                ${(agency.total_paid || 0).toLocaleString()}
              </TableCell>
              <TableCell className="text-right">
                <Badge className={collectionRateBadgeClass(agency.collectionRate)}>
                  {agency.collectionRate}%
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

export default AgencyComparisonTab;
